var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
import { Service } from '~/core/service';
var ImportExcelConfigService = /** @class */ (function (_super) {
    __extends(ImportExcelConfigService, _super);
    function ImportExcelConfigService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取映射字段
     */
    ImportExcelConfigService.prototype.templateDataQuery = function (data, page, sort) {
        return this.netService.send({
            server: dataimpService.importExcelConfigController.templateDataQuery,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 获取映射字段
     */
    ImportExcelConfigService.prototype.getExcelList = function () {
        return this.netService.send({
            server: dataimpService.importExcelConfigController.getExcelList,
        });
    };
    /**
     * Excel解析头部信息
     */
    ImportExcelConfigService.prototype.parserTemplateHeader = function (data) {
        return this.netService.send({
            server: dataimpService.importExcelConfigController.parserTemplateHeader,
            data: data,
        });
    };
    /**
     * 新增Excel导入摸板
     */
    ImportExcelConfigService.prototype.createExcelExportConfig = function (data) {
        return this.netService.send({
            server: dataimpService.importExcelConfigController.createExcelExportConfig,
            data: data,
            loading: true
        });
    };
    /**
     * 修改Excel导入摸板
     */
    ImportExcelConfigService.prototype.updateExcelExportConfig = function (data) {
        return this.netService.send({
            server: dataimpService.importExcelConfigController.updateExcelExportConfig,
            data: data,
            loading: true
        });
    };
    /**
     * 删除Excel模板
     */
    ImportExcelConfigService.prototype.deleteExcelData = function (data) {
        return this.netService.send({
            server: dataimpService.importExcelConfigController.deleteExcelData,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], ImportExcelConfigService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], ImportExcelConfigService.prototype, "templateDataQuery", null);
    __decorate([
        Debounce()
    ], ImportExcelConfigService.prototype, "getExcelList", null);
    __decorate([
        Debounce()
    ], ImportExcelConfigService.prototype, "parserTemplateHeader", null);
    __decorate([
        Debounce()
    ], ImportExcelConfigService.prototype, "createExcelExportConfig", null);
    __decorate([
        Debounce()
    ], ImportExcelConfigService.prototype, "updateExcelExportConfig", null);
    __decorate([
        Debounce()
    ], ImportExcelConfigService.prototype, "deleteExcelData", null);
    return ImportExcelConfigService;
}(Service));
export { ImportExcelConfigService };
